import CryptoJS from 'crypto-js';

const SECRET_KEY = import.meta.env.VITE_CRYPTO_SECRET_KEY ;
const ENCRYPTION_PREFIX = 'ENC_';

const safeParse = (value) => {
  try { return JSON.parse(value); } catch { return null; }
};

export const encryptData = (data) => {
  try {
    return ENCRYPTION_PREFIX + CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  } catch {
    return null;
  }
};

export const decryptData = (encryptedData) => {
  if (!encryptedData?.startsWith(ENCRYPTION_PREFIX)) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData.slice(ENCRYPTION_PREFIX.length), SECRET_KEY);
    return safeParse(bytes.toString(CryptoJS.enc.Utf8));
  } catch {
    return null;
  }
};

export const setEncryptedStorage = (key, data) => {
  const encrypted = encryptData(data);
  if (!encrypted) return false;
  localStorage.setItem(key, encrypted);
  return true;
};

export const getEncryptedStorage = (key) => {
  const encrypted = localStorage.getItem(key);
  return encrypted ? decryptData(encrypted) : null;
};

export const removeEncryptedStorage = (key) => localStorage.removeItem(key);